<div class="allcp-form mw400 auth-page login-panel" id="forgot">
    <a href="/login">
        <img src="/landing/img/logo.svg" alt="HODXpress Login" class="img img-responsive auth-logo">
    </a>
	<div class="panel">
        <div class="panel-body register pn mv10">
            <form ng-submit="forgot(email)">
                <h3>Forgot my password</h3>
                <p>Please enter the email address you'd like your password reset information sent to.</p>
                <div class="section">
                    <input type="text" ng-model="email" id="email" class="gui-input" placeholder="E-Mail" required>
                </div>
				<div class="section">
                    <button type="submit" class="hod-button orange pull-right ladda-button" data-style="expand-right" id="loginButton">
                        <span class="ladda-label">Reset my password</span>
                        <span class="ladda-spinner"></span><span class="ladda-spinner"></span>
                    </button>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
    <img src="/landing/img/envolope.svg" alt="HODXpress Forgot" class="auth-page-box-forgot">
    <br> <br>
	<div class="col-md-12 text-center footer-copy">
		<p>© 2024 HODXpress</p>
	</div>
</div>